import React, { useEffect, useState } from "react";
import { AppProvider as PolarisProvider } from "@shopify/polaris";
import { Provider as AppBridgeProvider } from '@shopify/app-bridge-react';
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import createApp from "@shopify/app-bridge";
import { Page, Text } from "@shopify/polaris";
import axios from "axios";
import "./App.css";
import Dashboard from "./Components/Dashboard";
import ArticleDetail from "./Components/ArticleDetail";
import AllPostTable from "./Components/AllPostTable";
import WelcomePage from "./Components/WelcomePage";

const apiKey = process.env.REACT_APP_SHOPIFY_API_KEY;


function AppRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shop = searchParams.get("shop");
  const host = searchParams.get("host");

  useEffect(() => {
    if (!shop || !host) return;

    const initializeApp = async () => {
      try {
        const app = createApp({ apiKey, host, forceRedirect: true });
        console.log("AppBridge initialized:", app);
      } catch (error) {
        window.location.assign(`/?shop=${shop}&host=${host}`);
        return;
      }

      try {
        const response = await axios.get(`/analytics/check-shop-data/?shop=${shop}`);
        const welcomeShown = response.data?.welcome_shown === true;

        if (welcomeShown) {
          navigate(`/dashboard?shop=${shop}&host=${host}`, { replace: true });
        } else {
          navigate(`/welcome?shop=${shop}&host=${host}`, { replace: true });
        }
      } catch (err) {
        navigate(`/dashboard?shop=${shop}&host=${host}`, { replace: true });
      }
    };

    if (window.top === window.self) {
      window.location.assign(`https://${shop}/admin/apps/analyticshero`);
    } else {
      initializeApp();
    }
  }, [shop, host, navigate]);

  return null;
}



function App() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopOrigin = searchParams.get("shop") || location.state?.shop;

  return (
    <PolarisProvider>
      {/* <Layout shopOrigin={shopOrigin} apiKey={apiKey}> */}
      <Routes>
        <Route path="/app/" element={<AppRedirect />} />
        <Route
          path="/welcome"
          element={<WelcomePage shopOrigin={shopOrigin} />}
        />

        <Route
          path="/dashboard"
          element={<Dashboard shopOrigin={shopOrigin} apiKey={apiKey} />}
        />
        <Route
          path="/article/:articleId"
          element={<ArticleDetail shopOrigin={shopOrigin} apiKey={apiKey} />}
        />
        <Route path="/all-posts" element={<AllPostTable shopOrigin={shopOrigin} apiKey={apiKey} />} />
        <Route path="/" element={<AppRedirect />} />
      </Routes>
      {/* </Layout> */}
    </PolarisProvider>
  );
}

export default function AppWrapper() {
  // Get shop and host from the URL
  const location = window.location;
  const searchParams = new URLSearchParams(location.search);
  const shopOrigin = searchParams.get("shop");
  const host = searchParams.get("host");

  const config = {
    apiKey: process.env.REACT_APP_SHOPIFY_API_KEY,
    host: host, // or shopOrigin if that's what you use
    forceRedirect: true,
  };

  return (
    <BrowserRouter>
      <PolarisProvider config={config}>
        <App className="App" />
      </PolarisProvider>
    </BrowserRouter>
  );
}